import React, { useState } from "react";
import {Center, Box, Grid, GridItem, Text, Input, Button, InputGroup, InputLeftAddon } from "@chakra-ui/react";
import Autosuggest from "react-autosuggest";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { HmacMD5 } from "crypto-js";

// Default Base URL
const baseUrl = window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
    process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL;

export default function Rates() {    
    
    // Set small screen size
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 700px)"
    });

    // Set Count Variable
    var count = 0;

    // Set state variables
    const [accessToken , setAccessToken] = useState(null);
    const [sharedToken, setSharedToken] = useState(null);
    const [emailAddress , setEmailAddress] = useState(null);
    const [tokenExecuted, setTokenExecuted] = useState(false);    
    const [submittedDetails, setSubmittedDetails] = useState(false);
    const [propertyAddress, setPropertyAddress] = useState("");
    const [propertySuggestions, setPropertySuggestions] = useState([]);
    const [propertyTimer, setPropertyTimer] = useState(null);
    const [reference, setReference] = useState(null);
    const [pleaseWait, setPleaseWait] = useState(false);

    if (!tokenExecuted) {
        retreiveAccessToken();

        var thisReference = "INV-RTE" + new Date().getTime();
        setReference(thisReference);
    }

    function retreiveAccessToken() {        
        // Retreive Access Token for payment.
        fetch(baseUrl + "rates/fz-access-token", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setAccessToken(response.access_token);
            setSharedToken(response.shared_secret);
        })
        .catch(error => console.log(error));

        setTokenExecuted(true);
    }

    // Called when clicking submit and pay button
    function handleValidation() {
        // Make sure count starts off as 0
        count = 0;
        // Get Required Fields
        var propertyNumber = document.getElementById("propertyNumber");
        var propertyAddress = document.getElementById("propertyAddress");
        var firstName = document.getElementById("firstName");
        var lastName = document.getElementById("lastName");
        var emailAddress = document.getElementById("emailAddress");
        var amountToPay = document.getElementById("amountToPay");

        // Add all required fields into an array
        var requiredFields = [propertyNumber, propertyAddress, firstName, lastName, emailAddress, amountToPay];
            
        // Loop through the array and validate each item
        requiredFields.forEach(function(thisField){
            checkInputHasValue(thisField);
        });

        ValidateEmail(emailAddress);
        ValidateAmount(amountToPay);
        ValidatePropertyNumber(propertyNumber);

        if (count === 0) {            
            if (accessToken != null) {

                var ratesPaymentModel = JSON.stringify({
                    "propertyNumber": propertyNumber.value,
                    "propertyAddress": propertyAddress.value,
                    "firstName": firstName.value,
                    "lastName": lastName.value,
                    "emailAddress": emailAddress.value,
                    "accessToken": accessToken,
                    "amount": parseFloat(amountToPay.value).toFixed(2),
                    "invoiceNumber" : reference
                });
                
                setEmailAddress(emailAddress.value);
                var amount = parseFloat(amountToPay.value * 100).toFixed();

                ratesPaymentPost(ratesPaymentModel, amount);
            }
        }
    }

    function navigateToFatZebra(amount) {
        // Navigate to FatZebra Payment
        var sharedSecret = sharedToken; 
        var fzUsername = "TESTmaitland";
        var paymentUrl = "https://paynow.pmnts-sandbox.io/v2";                
        var returnPath = "https://mcc-ae-nonprod-forms.azurewebsites.net/ratespaid";
        if (window.location.origin === "https://forms.maitland.nsw.gov.au") {
            fzUsername = "maitlandrates";
            paymentUrl = "https://paynow.pmnts.io/v2";
            returnPath = "https://forms.maitland.nsw.gov.au/ratespaid";
        }
        
        var encrypted = HmacMD5([reference, amount, 'AUD', returnPath].join(':'),sharedSecret).toString();

        setSubmittedDetails(true);    
        window.top.location.href = `${paymentUrl}/${fzUsername}/${reference}/AUD/${amount}/${encrypted}?return_path=${returnPath}&amp;cards=&amp;show_email=false&amp;enable_sca=false&amp;hide_button=false&amp;tokenize_only=false&amp;hide_logos=true`;          
    }

    // Validation
    function checkInputHasValue(property) {
        if (property.value.length === 0) {
            flagRequired(property);
            count++;
        } else {
            removeFlagRequired(property);
        }
    }

    function flagRequired(property) {
        property.style.borderColor = "red";
    } 

    function removeFlagRequired(property) {
        property.style.borderColor = "lightgray";
    }

    // Validate that the value entered looks like an email address.
    function ValidateEmail(input) {
        // Validation Regular Expression
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;      
        if (!input.value.match(validRegex)) {  
            // If invalid flag that it's required and add to error count      
            flagRequired(input);
            count++;
        } 
    }

    // Validate that payable amount is greater than 0
    function ValidateAmount(input) {
        if (input.value <= 0) {
            flagRequired(input);
            count++;
        }
    } 

     // Validate that property number is only 6 digits
    function ValidatePropertyNumber(input) {
        if (input.value.length !== 6) {
            flagRequired(input);
            count++;
        }
    } 

    // Api call
    function ratesPaymentPost(ratesPaymentModel, amount) {
        // Store details on property certificate
        // Set please wait for slow browsers
        setPleaseWait(true);
        fetch(baseUrl + "rates/payments", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: ratesPaymentModel
        })
        .then(response => response.json())
        .then(response => {           
            console.log(response); 
            if (response.statusCode === 200) {
                navigateToFatZebra(amount);
            }
        })
        .catch(error => {
            console.log(error);            
            // Undo please wait if error
            setPleaseWait(false);
        });
    }

    // Api call
    function deleteRatesPaymentPost() {
        // Store details on property certificate
        var parameters = "?emailAddress=" + emailAddress + "&accessToken=" + accessToken;

        fetch(baseUrl + "rates/payments" + parameters, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(response => {           
            console.log(response); 
            setPleaseWait(false);
        })
        .catch(error => console.log(error));
        return true;
    }
    
    function handleCancelAndReturn() {
        // Return to page > Delete cancel from database if not paid > reload page
        setSubmittedDetails(false);
        deleteRatesPaymentPost();
        window.location.reload();
    }

    // Input change for property
    const propertyInputChanged = e => {

        clearTimeout(propertyTimer);

        const newTimer = setTimeout(() => {
            AutoSuggestFunctionMaitlandOnly();
        }, 500);

        setPropertyTimer(newTimer);
    }

    // Use AutoSuggest api from Wastetrack layer of ARCGIS, displayed only Maitland LGA Address
    function AutoSuggestFunctionMaitlandOnly() {
        setTimeout(function(){
            var propertyAddress = document.getElementById('propertyAddress');
            if(propertyAddress.value.length > 4) {

                fetch(baseUrl + "wastetrack/search-bin?addressText=" + propertyAddress.value, {
                    method: "GET"
                })
                .then(response => response.json())
                .then(response => {           
                    const theseSuggestions = [];
                    var count = 0;
                    response.forEach(function(thisSuggestion) {
                        theseSuggestions[count] = thisSuggestion;
                        count++;
                    })

                    setPropertySuggestions(theseSuggestions.map(row => ({
                        address: (row.unit_number ? `${row.unit_number}/` : "") + row.street_number + " " + row.street_name + ", " + row.suburb + ", " + row.postcode
                    })));
                })
                .catch(error => console.log(error));
            }
        }, 200);
    }

    // Set variables from autosuggest on Property Address to autocomplete PropertyAddress, Suburb and PostCode
    function SetPropertyAddressDetails(value) {
        // Return this value 
        return value;
    }

    return (
        <>
            <Helmet>
                <meta http-equiv="Content-Security-Policy" content={`default-src 'self'; style-src 'self' https://maitlandapi.wpengine.com/mccds/ 'unsafe-inline'; 
                    connect-src 'self' ${baseUrl}rates/ ${baseUrl}wastetrack/`} />
            </Helmet>
            {!submittedDetails &&
            <Box marginTop='2%' marginLeft='5%' maxW='90%'>
                <Grid templateColumns='repeat(1, 1fr)' gap={3}>
                    <GridItem w='100%'>
                        <Text fontSize='2xl' fontWeight="bold">Property Details</Text>
                    </GridItem>
                    <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Property Number<span className="requiredField">Required</span></Text>
                            <Input id="propertyNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type='number' onWheel={(e) => e.target.blur()} />
                            <Text fontSize="md">This is the six digit number on the bottom of your rates notice.</Text>
                        </GridItem>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Property Address<span className="requiredField">Required</span></Text>
                            <Autosuggest 
                                    inputProps={{
                                        autoComplete: "abcd",
                                        name: "propertyAddress",
                                        id: "propertyAddress",
                                        value: propertyAddress,
                                        onChange: (_event, { newValue }) => {
                                            setPropertyAddress(newValue);
                                        }
                                    }}
                                    suggestions={propertySuggestions}
                                    onSuggestionsFetchRequested={async ({ value }) => {
                                        if (!value) {
                                            setPropertySuggestions([]);
                                            return;
                                        }
                                        try {
                                            propertyInputChanged();
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }}
                                    onSuggestionsClearRequested={() => {
                                        setPropertySuggestions([]);
                                    }}
                                    getSuggestionValue={suggestion => SetPropertyAddressDetails(suggestion.address)}
                                    renderSuggestion={suggestion => <div className="binSuggestion">
                                        {suggestion.address}
                                    </div>}
                                />
                        </GridItem>
                    </Grid>
                    <GridItem w='100%'>
                        <Text fontSize='2xl' fontWeight="bold">Contact Details</Text>
                    </GridItem>
                    <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">First Name/Company Name<span className="requiredField">Required</span></Text>
                            <Input id="firstName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                        </GridItem>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Last Name/Contact Person<span className="requiredField">Required</span></Text>
                            <Input id="lastName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                        </GridItem>
                    </Grid>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Email Address<span className="requiredField">Required</span></Text>
                        <Input id="emailAddress" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize='2xl' fontWeight="bold">Payment Details</Text>
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Amount to pay<span className="requiredField">Required</span></Text>
                        <InputGroup>
                            <InputLeftAddon children="$" height="40px" />
                            <Input id="amountToPay" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type="number" onWheel={(e) => e.target.blur()} />
                        </InputGroup>
                    </GridItem>
                    <GridItem w='100%'>
                        <Button w="100%" variant="Primary" padding="25px" onClick={() => handleValidation()} isDisabled={pleaseWait}>{pleaseWait ? `Please Wait` : "Submit and Pay"}</Button>
                    </GridItem>
                </Grid>
            </Box>
            }
            {submittedDetails &&
            <>
                <Center>
                    <Button onClick={() => handleCancelAndReturn()} size="lg" variant="Primary">&lt; Back</Button>
                </Center>
            </>
            }
        </>
    )
}